export const iconFontAwesomeHumanitarianSuitcaseMedical = (
	<i className="fa-solid fa-suitcase-medical"></i>
);
